import { render } from "./AddModalCategProduit.vue?vue&type=template&id=f833832e&ts=true"
import script from "./AddModalCategProduit.vue?vue&type=script&lang=ts"
export * from "./AddModalCategProduit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__